<div class="flex max-w-[800px] justify-center gap-4 flex-col sm:flex-row">
  <div class="flex flex-col justify-center gap-4">
    <h1 class="heading-2 text-petrol-650">Anmeldung erforderlich</h1>
    <p>
      Wenn Sie ein Authentifizierungsmedium (DATEV SmartCard / DATEV mIDentity /
      DATEV SmartLogin) nutzen, melden Sie sich bitte an!
    </p>
    <dackl-section-message headline="Hinweis" type="info">
      <p>
        Spezielle Informationen für
        <strong>Neukunden</strong>
        finden Sie hier:
        <a href="https://go.datev.de/erstinstallation" target="_blank" rel="noopener noreferrer">go.datev.de/erstinstallation</a>.
      </p>
      <p>
        Alle Informationen rund um das Thema
        <strong>Installation</strong>
        finden Sie hier:
        <a href="https://go.datev.de/service-installation" target="_blank">go.datev.de/service-installation</a>.
      </p>
    </dackl-section-message>
    <p>
      <button mat-button color="primary" (click)="login()">Anmelden</button>
    </p>
  </div>
</div>
